import { formatCurrency } from '../../helpers/formatCurrency';
import { useTweenedNumber } from '../../hooks/useTweenedNumber';

// Valor monetário que anima até o novo número (final sempre exato).
export function TweenedCurrency({ value }) {
  return formatCurrency(useTweenedNumber(Number(value)));
}

// Inteiro que anima até o novo valor (quantidades, créditos).
export function TweenedInteger({ value }) {
  return Math.round(useTweenedNumber(Number(value)));
}
